module.exports = __webpack_public_path__ + "static/img/sing.03e5f605.gif";